import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/components/MDXPageLayout.js";
import PageBanner from '../components/PageBanner';
import Gallery from '../components/Gallery';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



<PageBanner styleId={1} title={'La galerie'} description={'Les photos de nos évènements'} mdxType="PageBanner" />
<section id="one">
<div className="inner">
<Gallery mdxType="Gallery" />
</div>
</section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      